import styled from "styled-components";

export const StyledLabelContainer = styled.div`
  display: flex;
  padding: 1.25rem 1rem 1rem 0rem;
  align-items: center;
  gap: 1.875rem;
  align-self: stretch;
  width: 100%;
  border-radius: 0.5rem;
`;
